import { Box, FormControl, InputLabel } from "@mui/material";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";

interface Props {
  onTextChange?: (val: string) => void;
  onSelectChange?: (code: string) => void;
  onSelectValue?: string;
  hasError?: boolean;
  inputLabel: string;
  placeholder?: string;
  setHasError?: (val: boolean) => void;
  error?: boolean;
  name?: string;
  requiredField?: boolean;
  helperText?: string;
  onTextValue?: string;
}

const GKPhoneInput = (props: Props) => {
  const {
    onTextChange,
    onTextValue,
    onSelectValue,
    onSelectChange,
    error,
    helperText,
    inputLabel,
    requiredField,
  } = props;

  return (
    <FormControl
      fullWidth
      variant="outlined"
      error={error}
      sx={{ position: "relative" }}
    >
      <InputLabel
        shrink
        sx={{
          background: "#fff",
          px: "4px",
          color: error ? "red" : "rgba(0,0,0,0.6)",
          fontSize: 14,
          position: "absolute",
          top: 0,
          left: 10,
          zIndex: 1,
          "&.Mui-focused": {
            color: error ? "var(--error-color)" : "rgba(0,0,0,0.6)",
          },
          "&.MuiInputLabel-shrink": {
            transform: "translate(0, -1.5px) scale(0.75)",
          },
        }}
      >
        {inputLabel}
        {requiredField && <span style={{ color: "red" }}> *</span>}
      </InputLabel>

      <Box>
        <PhoneInput
          inputProps={{
            name: "phone",
            required: requiredField,
          }}
          inputStyle={{
            borderRadius: "8px",
            width: "100%",
            height: "53px",
            borderColor: error ? "red" : "#ccc",
          }}
          specialLabel="" // disable default floating label
          value={`${onSelectValue || ""}${onTextValue || ""}`}
          countryCodeEditable={false}
          onChange={(value, country: any) => {
            const dialCode = `+${country?.dialCode}`;
            const phoneNumber = value
              .replace(country?.dialCode, "")
              .replace(/\s+/g, "");

            if (onSelectChange) onSelectChange(dialCode);
            if (onTextChange) onTextChange(phoneNumber);
          }}
        />
      </Box>

      {helperText && (
        <div
          style={{
            fontSize: 12,
            color: error ? "red" : "#6b6b6b",
            marginTop: 4,
          }}
        >
          {helperText}
        </div>
      )}
    </FormControl>
  );
};

export default GKPhoneInput;
